import React from "react";
import "./Contact.css";
import NavBar from "../NavBar/NavBar";
import Footer from "../Footer/Footer";
import { SERVER_ADDRESS } from "../../../constants";

class Contact extends React.Component {
    constructor(props) {
        super(props);

        this.contact = this.contact.bind(this);
    }

    async contact() {
        let name = document.getElementById("name").value;
        let email = document.getElementById("email").value;
        let message = document.getElementById("message").value;
        
        let data = JSON.stringify({
            name: name,
            email: email,
            note: message
        });
        try {
            let result = await fetch(`${SERVER_ADDRESS}/contact`, {
                method: "POST",
                body: data,
                headers: {
                    "content-type": "application/json",
                    "accept": "application/json"
                }
            })
            if(result) {
                document.getElementById("name").value = "";
                document.getElementById("email").value = "";
                document.getElementById("message").value = "";
            }
        } catch(error) {
            console.log(error);
        }
    }

    render() {
        return (
            <div>
                <NavBar/>
                <div id="contact-form-container">
                    <h2>Get in touch.</h2>
                    <p>Call us at (917) 215-9041, Email us at rae@kidsinseats.org, or fill out the form below.</p>
                    <p>We'd love to hear from you. Send us a message and we'll get back to you as soon as possible.</p>
                    <form id="contact-form">
                        <input id="name" placeholder="Your Name"></input>
                        <input id="email" placeholder="Your Email"></input>
                        <textarea id="message" placeholder="Your Message"></textarea>
                    </form>
                    <div id="contact-button" onClick={this.contact}>Contact</div>
                </div>
                <Footer/>
            </div>
        );
    }
}

export default Contact;
